import { PanelLeft, Plus } from 'lucide-react'
import { useStore } from '../../store'

/** Header for the Portfolio / Settings views — gives a menu (sidebar) + new chat
 *  so you can always navigate away, especially on mobile where there's no rail. */
export function ViewHeader({ title }: { title: string }) {
  const toggleSidebar = useStore((s) => s.toggleSidebar)
  const newChat = useStore((s) => s.newChat)
  return (
    <header className="flex h-[52px] shrink-0 items-center justify-between gap-2 border-b border-[var(--line-soft)] px-3">
      <div className="flex min-w-0 items-center gap-1.5">
        <button
          onClick={() => toggleSidebar()}
          title="Menu"
          className="inline-flex h-8 w-8 items-center justify-center rounded-lg text-fg-subtle transition-colors hover:bg-[var(--color-surface-2)] hover:text-fg"
        >
          <PanelLeft size={17} />
        </button>
        <h2 className="truncate text-[13.5px] font-medium text-fg">{title}</h2>
      </div>
      <button
        onClick={() => newChat()}
        title="New chat"
        className="inline-flex items-center gap-1.5 rounded-lg border border-[var(--line-soft)] bg-[var(--color-surface-2)] px-2.5 py-1.5 text-[12px] text-fg-muted transition-colors hover:border-[var(--line)] hover:text-fg"
      >
        <Plus size={14} /> <span className="hidden sm:inline">New chat</span>
      </button>
    </header>
  )
}
